import React from 'react';
import styled from 'styled-components';
import { Dropdown, token } from '@bynder/design-system';
import { IconSettings } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

import { WFGroupsModal } from '../WorkflowGroupsManagement/WFGroupsModal';
import { AccountMenuItem } from './AccountMenuItem';
import { useAccountMenuItems } from './useAccountMenuItems';
import { LiWithFocusHighlight } from '../CommonStyles';
import { BREAKPOINTS } from '../../breakpoints';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm
 */
export function AccountMenu() {
	const { translate } = useTranslate();
	const menuItems = useAccountMenuItems();

	const liStyles = {
		padding: `0 ${token.spacing5}`,
		height: 50,
		display: 'flex',
		alignItems: 'center',
	};

	if (menuItems.length === 0) {
		return <li className="touch-block" style={liStyles} />;
	}

	return (
		<Wrapper>
			<Dropdown
				trigger={({ isOpen, ...triggerProps }) => (
					<LiWithFocusHighlight
						className={`touch-block ${isOpen ? 'hover' : ''}`}
						style={liStyles}
						{...triggerProps}
					>
						<StyledAnchor
							href="#"
							onClick={(e) => e.preventDefault()} // to prevent it from replacing whatever # is in the href
							className="admin-dropdown settings"
							role="button"
						>
							<IconSettings />
							{translate('generalSettings')}
						</StyledAnchor>
					</LiWithFocusHighlight>
				)}
				minWidth="240px"
				noMaxHeight
			>
				{menuItems.map((item) => (
					<AccountMenuItem item={item} key={item.key} />
				))}
			</Dropdown>
			<WFGroupsModal />
		</Wrapper>
	);
}

// "font-size: 0" instead of not adding the text ("Settings") because I guess some portals overwrite it with custom theming
const StyledAnchor = styled.a`
	font-size: 0;
`;

const Wrapper = styled.div`
	display: block;

	@media (max-width: ${BREAKPOINTS.MOBILE}px) {
		display: none;
	}
`;
